export const isSavingTreatmentAbroad = (state) => state.isSavingTreatmentAbroad;
